import React, { Fragment, useState } from "react";
import { isMobile } from "react-device-detect";
import { Dialog } from "@material-ui/core";
import InventoryTaskForm from "./InventoryTaskForm";
import { DownloadSampleFile, DownloadInvTemplateFile } from "../apiServices";
import { convertFilterObject, removeEmptyKey, permissionCheckFnforCamo, getLocalStorageInfo } from "../../../../utils";
import CamoCTA from "../../../../shared_elements/components/cta/CamoCTA";

const InventorySearchBar = ({ applyingFilter, filterOptions, tabIndex, pageLoader, props, searchData, fileUploadData, importFile, exportReportFn, headerTsn, headerCsn, currentRecordPerPage, date_of_manufacture, uuid, getResponseBack, assetsDetail, basicDetails }) => {
	const [open, setOpen] = useState(false);
	const [formTitle, setFormTitle] = useState("");
	const [actionType, setActionType] = useState("");

	const boeingInstance = getLocalStorageInfo()?.defaultLessor?.id === 475;

	const addNewTask = () => {
		setOpen(true);
		setFormTitle("Add Inventory ");
		setActionType("add");
	};

	const importFileFunc = (e) => {
		const files = e.target.files;
		const formData = new FormData();
		formData.append("file", files[0]);
		importFile(formData, props, true);
		e.target.value = null;
	};

	const filterParams = convertFilterObject(removeEmptyKey(applyingFilter), filterOptions);

	return (
		<Fragment>
			<div id="AmpSearchBar">
				<CamoCTA
					searchPlaceholder="Search Part Number Serial Number,Description"
					onSearch={(value) => searchData({ target: { value } })}
					permissionCheck={!permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "C" }) || window?.location?.search.includes('archived-assets')}
					addLabel="ADD INVENTORY LIST"
					onAddFn={addNewTask}
					onImportFn={!boeingInstance ? importFileFunc : undefined}
					exportMenu={{
						exportReportFn: exportReportFn,
						files: [
							{ title: 'PDF', extension: 'pdf', key: '' },
							{ title: 'EXCEL', extension: 'xlsx', key: '' },
						],
					}}
					downloadSampleMenu={{
						exportReportFn: (file) => file.key === 'template'
							? DownloadInvTemplateFile({ download: file.extension, ...filterParams }, pageLoader, props, basicDetails)
							: DownloadSampleFile({ download: file.extension, ...filterParams }, pageLoader, props, basicDetails),
						files: [
							{ title: 'DOWNLOAD SAMPLE', extension: 'xlsx', key: 'sample' },
							{ title: 'TEMPLATE', extension: 'xlsx', key: 'template' },
						],
					}}
				/>
				<Dialog open={open} style={{ height: isMobile && "650px" }}>
					<InventoryTaskForm
						date_of_manufacture={date_of_manufacture}
						headerTsn={headerTsn}
						headerCsn={headerCsn}
						formTitle={formTitle}
						closeAddForm={() => setOpen(false)}
						addForm={() => setOpen(true)}
						props={props}
						actionType={actionType}
						fileUploadData={fileUploadData}
						currentRecordPerPage={currentRecordPerPage}
						uuid={uuid}
						getResponseBack={() => getResponseBack()}
						basicDetails={basicDetails}
						assetsDetail={assetsDetail}
					/>
				</Dialog>
			</div>
		</Fragment>
	);
};

export default InventorySearchBar;
